import { Button } from "antd";
import { useState } from "react";
import ModalWithForm, { FieldProps } from "src/components/ModalWithForm";
import { Configuration } from "src/models/ConfigurationModel";
import {
  useGetConfigurationByKeyQuery,
  useSetConfigurationMutation,
} from "src/store/apis/Configuration";

interface Props {
  configKey?: string;
}

export default function EditModal({ configKey }: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFormDisabled, setIsFormDisabled] = useState(true);

  const {
    data: editConfig,
    isLoading: isLoadingConfig,
    isFetching: isFetchingConfig,
    isSuccess: isSuccessConfig,
  } = useGetConfigurationByKeyQuery(
    {
      key: configKey ?? "",
    },

    { skip: !isModalOpen, refetchOnMountOrArgChange: true },
  );

  const isPendingConfig = isLoadingConfig || isFetchingConfig;

  const [setConfig, { isLoading: isPendingSetConfig }] =
    useSetConfigurationMutation();

  const handleConfirm = (data: { key: string; value: string }) => {
    if (!data.key) return;
    setConfig({
      key: data.key,
      value: data.value,
    }).then(() => setIsModalOpen(false));
  };

  const fields: FieldProps<Configuration>[] = [
    {
      label: "key",
      name: "key",
      type: "text",
      inputProps: {
        name: "key",
        disabled: true,
      },
    },
    {
      label: "Value",
      name: "value",
      type: "textarea",
      tooltip:
        editConfig?.result.pattern &&
        `Must follow pattern: ${editConfig?.result.pattern}`,
      rules: [
        {
          pattern: editConfig?.result.pattern
            ? new RegExp(editConfig?.result.pattern)
            : undefined,
          message: "Invalid Pattern",
        },
      ],
      inputProps: {
        name: "value",
        disabled: isFormDisabled,
      },
    },
  ];

  return (
    <>
      <div className="flex justify-between gap-4">
        <Button
          className={
            "rounded-sm text-12 border-0 font-bold uppercase bg-primary text-white disabled:bg-gray-500"
          }
          onClick={() => setIsModalOpen(true)}
          disabled={!configKey}
          loading={isPendingConfig}
        >
          Edit
        </Button>
      </div>
      <ModalWithForm
        open={isModalOpen && isSuccessConfig}
        onCancel={() => setIsModalOpen(false)}
        afterClose={() => setIsFormDisabled(true)}
        onConfirm={handleConfirm}
        isLoading={isPendingConfig || isPendingSetConfig}
        mode="edit"
        isEditing={!isFormDisabled}
        onEdit={() => setIsFormDisabled((prev) => !prev)}
        initialValues={{
          key: editConfig?.result.key,
          value: editConfig?.result.value,
        }}
        fields={fields}
      />
    </>
  );
}
